"use client";

import { useSyncExternalStore } from "react";

/** True on the client after hydration; false during SSR and the hydration pass (matches server HTML). */
export function useIsClient() {
  return useSyncExternalStore(_temp2, _temp3, _temp4);
}
function _temp4() {
  return false;
}
function _temp3() {
  return true;
}
function _temp2() {
  return _temp;
}
function _temp() {}